import { SOCIETY_POWER } from "@/config/config";
import { nav } from "@/store/interface/common";
import { getBadge, getCountO, getType, getSubCount } from "@/utils/badges";
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";

export default () => {
  const store = useStore();
  const items = ref<nav[]>(store.getters.getNavArr);
  const currentData = computed(() => store.getters.getTagCurrentData);
  const currentPower = computed(() => store.getters.getCurrentPower);
  const badges = computed(() => store.getters.getBadges);
  const thisCompany = computed(() => store.getters.getThisCompany);
  const isDisabled = ref(false);

  watch(
    [currentPower, currentData, badges],
    async ([currentPower, currentData, badges]) => {
      const o = currentPower;
      const { companynumber, industryid } = currentData?.data?.userinfo || {};
      isDisabled.value = industryid;
      if (!companynumber) return;
      if (!o || !badges) return;
      const array = Object.values(SOCIETY_POWER).map((arr) => [arr[0], o[arr[1]]]);
      const badge = getBadge(badges, companynumber);

      items.value.filter((item) => {
        const arr = array.find((r) => r[0] == item.name);
        const type = getType(item.name);
        if (type && badge) {
          const subList = getCountO(badge.list, type);
          const countO = getSubCount(subList?.subList, thisCompany.value.subId);
          if (countO) item.dot = countO.count;
          else item.dot = 0;
        }
        if (arr?.length) item.isHide = !arr[1];
      });
      await store.dispatch("setNavs", items);
    },
    { deep: true, immediate: true }
  );
  return { items, isDisabled };
};
